import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="m-auto text-center justify-content-center">
      <h1 className="text-white mt-5">{t('bet.comingSoon')}</h1>

      <div className="w-100 my-2 d-flex justify-content-center ">
        <button
          type="submit"
          className="bg-purple-dark btn fw-semibold"
          onClick={(e) => {
            navigate(-1)
          }}
        >
          <span className="bg-purple text-white">Go Back</span>
        </button>
      </div>
    </div>
  );
};

export default NotFound;
